import { render, staticRenderFns } from "./AssignCompanyAccess.vue?vue&type=template&id=90e84630"
import script from "./AssignCompanyAccess.vue?vue&type=script&lang=js"
export * from "./AssignCompanyAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports